import React from "react";
import { Link, Route } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";

const ActiveLink = ({ label, to, activeOnlyWhenExact, icon }) => {
  return (
    <Route
      path={to}
      exact={activeOnlyWhenExact}
      children={({ match }) => (
        <Link className={match ? "active" : ""} to={to}>
          <i className={icon} /> {label}
        </Link>
      )}
    />
  );
};

const SideBar = props => {
  const { links, authenticated, currentUserRole } = props;

  if (!authenticated) return <div> </div>;

  const filteredLinks = links.all.map(link => {
    if (!!link.roles) {
      if (link.roles.includes(currentUserRole)) {
        return link;
      } else {
        return null;
      }
    }

    return link;
  });

  let lis = _.compact(filteredLinks).map((link, idx) => {
    return (
      <li key={idx}>
        <ActiveLink
          activeOnlyWhenExact
          to={link.link}
          icon={link.icon}
          label={link.label}
        />
      </li>
    );
  });

  return (
    <div className="sidebar">
      <ul className="xp-side-nav-links">{lis}</ul>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    links: {
      all: [
        {
          link: "/dashboard",
          label: "Dashboard",
          icon: "fa fa-tachometer"
        },
        {
          link: "/members",
          label: "Members",
          icon: "fa fa-users"
        },
        {
          link: "/reports",
          label: "Reports",
          icon: "fa fa-area-chart"
        },
        {
          link: "/admins",
          label: "Administrators",
          icon: "fa fa-user"
        },
        {
          link: "/events",
          label: "Events",
          icon: "fa fa-calendar"
        },
        {
          link: "/notices",
          label: "Notices",
          icon: "fa fa-file-text-o"
        },
        {
          link: "/prayers",
          label: "Monthly Prayers",
          icon: "fa fa-plus"
        },
        {
          link: "/assets",
          label: "Assets",
          icon: "fa fa-picture-o"
        }

        /*{
          link: "/pledges",
          label: "Pledges",
          icon: "fa fa-money",
           roles: ["super_admin"]
        }*/
      ]
    },
    currentUserRole: state.app.role
  };
};

export default connect(mapStateToProps)(SideBar);



// WEBPACK FOOTER //
// ./src/components/SideBar.js